export default function Tracking(app) {
    app.api.Tracking = Object.freeze({
        navigation,
        event
    })


    /* ------------- PIWIK PRO CUSTOM EVeNT TRACKING ------------- */
    // Array containing a tracking function’s name followed by its arguments. The number of arguments and their meaning are determined by the tracking function.
    // ["trackEvent", "video", "video-paused", "intro.mp4", 15.2];

    /* Custom events
        trackEvent(category, action[, name[, value[, dimensions]]])
        Tracks custom event, e.g. when visitor interacts with the page.

        Arguments:	
        category (string) – Required Event category
        action (string) – Required Event action
        name (string) – Optional Event name
        value (number) – Optional Event value
        dimensions (object) – Optional Custom dimensions to pass along with the custom event
    */

    // Navigation with hooks in the $Router
    function navigation(action, property, payload) {
        console.log(`Tracking Page View => \nURL: ${property}`);
        if(_paq != undefined)
            _paq.push(["trackPageView"]);
    }
    
    // Explicitly called events with js (buttonclicks etc.)
    function event(action, property, payload) {
        

        let trackingObject = [action, property, payload]
            
        CreateLog(trackingObject)
    }
    
    function CreateLog(data) {

        if(_paq)
            _paq.push(data);
    }
}